import { curry } from 'lodash'

const reportsSelector = (state) => state.report.dashboard.reports
const filtersSelector = (state) => state.report.dashboard.filters

const querySelector = curry((state, value) => {
  return state.report.dashboard.query[value.label].query
})

const queryChangesSelector = curry((state, value) => {
  let values = state.report.dashboard.query[value.label].changes
  let selection = []
  values.forEach(value => {
    value.id.forEach(id => {
      selection.push({ ...value, id: id })
    })
  })
  return selection
})

const querySourceSelector = curry((state, value) => {
  const source = state.report.dashboard.query[value.label].source
  const results = Object.values(source).map(sou => ({ value: sou.name, label: sou.name, id: sou.id }))
    .reduce((result, { id, value, ...rest }) => {
      const previous = result[value]
      let updated = { ...rest, id: [id], value }
      if (previous) {
        updated.id = [...updated.id, ...previous.id]
      }
      return {
        ...result,
        [value]: updated
      }
    }, {})
  return Object.values(results)
})

const queryChangesUiSelector = curry((state, value) => {
  return state.report.dashboard.query[value.label].changes
})

const projectCountsQuerySelector = (state) => state.report.dashboard.chartQuery.projectCountsQuery
const projectSpecificationQuerySelector = (state) => state.report.dashboard.chartQuery.projectSpecificationQuery
const aeResourcesQuerySelector = (state) => state.report.dashboard.chartQuery.aeResourcesQuery
const aeRegionsQuerySelector = (state) => state.report.dashboard.chartQuery.aeRegionsQuery

const dashboardQueryUISelector = (state) => state.report.dashboard.dashboardQueryUI

export {
  reportsSelector,
  filtersSelector,
  querySelector,
  queryChangesSelector,
  queryChangesUiSelector,
  querySourceSelector,
  projectCountsQuerySelector,
  projectSpecificationQuerySelector,
  aeResourcesQuerySelector,
  aeRegionsQuerySelector,
  dashboardQueryUISelector
}